import styled from '@emotion/styled';

import { Device } from './Device';
import { Flow } from './Flow';
import { Heading3 } from './Heading3';
import { InsightList } from './InsightList';
import { InsightListItem } from './InsightListItem';
import { Mood } from './Mood';
import { Shape } from './Shape';
import { User } from './User';
import { ZoneList } from './ZoneList';
import { ZoneListItem } from './ZoneListItem';

export const ContentLoader = {
  Shape,
  Device,
  Mood,
  Flow,
  User,
  ZoneList,
  ZoneListItem,
  InsightList,
  InsightListItem,
  Heading3,
};

export const SVGRoot = styled.svg`
  display: block;
`;
